import { ConstructionIcon } from 'lucide-react';
import { useEffect } from 'react';

export function MaintenancePage() {
  useEffect(() => {
    document.title = 'Maintenance - Driver';
  }, []);

  return (
    <main className="flex min-h-screen flex-col bg-white">
      {/* Header with logo */}
      <header className="p-6">
        <div className="flex items-center gap-2">
          <img
            src="/driver_logo.svg"
            alt="Driver"
            width={20}
            height={20}
            className="transform transition-all ease-in-out"
          />
          <span className="text-lg font-semibold text-gray-900">Driver</span>
        </div>
      </header>

      {/* Main content - centered */}
      <div className="flex flex-1 items-center justify-center px-6">
        <div className="w-full max-w-lg rounded-lg border border-orange-600 bg-white p-6">
          <div className="flex items-start gap-3">
            <ConstructionIcon className="mt-0.5 h-5 w-5 shrink-0 text-orange-600" />
            <div className="space-y-3">
              <h1 className="text-base leading-4 font-medium text-orange-600">
                Driver is undergoing scheduled maintenance
              </h1>
              <p className="text-sm leading-5 font-normal text-orange-600">
                You are seeing this message because Driver is currently undergoing maintenance. We appreciate your
                patience as we work to improve our systems and bring you infrastructure upgrades.
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
